import { render, staticRenderFns } from "./peopleBaseInfo.vue?vue&type=template&id=09eab51e&scoped=true&"
import script from "./peopleBaseInfo.vue?vue&type=script&lang=ts&"
export * from "./peopleBaseInfo.vue?vue&type=script&lang=ts&"
import style0 from "./peopleBaseInfo.vue?vue&type=style&index=0&id=09eab51e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eab51e",
  null
  
)

export default component.exports